import { deleteNotes } from "http/fundLync/entityAndAddress.helper";

export const useDeleteNote = async (id, setRefetch, setToastInfo) => {
  try {
    const response = await deleteNotes({ id: id });
    if (response.status === "success") {
      setToastInfo({
        message: response.message,
        showToast: true,
        role: "success",
      });
      setRefetch((prev) => !prev);
    } else {
      setToastInfo({
        message: response.message,
        showToast: true,
        role: "success",
      });
      setRefetch((prev) => !prev);
    }
  } catch (error) {
    setToastInfo({
      message: "An error occurred while deleting the note.",
      showToast: true,
      role: "error",
    });
    return false;
  }

};
